import React__default from 'react';
import AnnouncementBarArrowDesktop from '../assets/icons/announcement-bar-desktop.icon.js';
import AnnouncementBarArrowMobile from '../assets/icons/announcement-bar-mobile.icon.js';
import Typography from '../Atoms/Typography.js';
import Anchor from '../Atoms/Anchor.js';
import { useTranslation } from 'react-i18next';
import ColorUtil from '../Utils/color.util.js';

function AnnouncementBar(_a) {
    var announcement = _a.announcement, url = _a.url, backgroundColor = _a.backgroundColor;
    useTranslation().t;
    var _b = React__default.useState(), announcementTextColor = _b[0], setAnnouncementTextColor = _b[1];
    React__default.useEffect(function () {
        var hexCode = backgroundColor;
        if (ColorUtil.checkDarkOrLight(hexCode) === 'light') {
            setAnnouncementTextColor('#000000');
        }
        else {
            setAnnouncementTextColor('#ffffff');
        }
    }, [backgroundColor]);
    return (React__default.createElement("div", { className: "announcement-bar-grandparent", style: { backgroundColor: "".concat(backgroundColor) } },
        React__default.createElement("div", { className: "announcement-bar-parent" },
            React__default.createElement("div", { className: "announcement-bar" },
                React__default.createElement("div", { className: "announcement-text-desktop" },
                    React__default.createElement(Typography, { classes: "text-announcement", variant: "bodyTextOneMain", color: announcementTextColor },
                        announcement,
                        url && (React__default.createElement("div", { className: "arrow-url" },
                            React__default.createElement(Anchor, { classes: "announcement-arrow", href: "".concat(url), newTab: true },
                                React__default.createElement(AnnouncementBarArrowDesktop, { fill: announcementTextColor })))))),
                React__default.createElement("div", { className: "announcement-text-mobile" },
                    React__default.createElement(Typography, { classes: "text-announcement", variant: "bodyTextTwoMain", color: announcementTextColor },
                        announcement,
                        url && (React__default.createElement(Anchor, { classes: "announcement-arrow", href: "".concat(url), newTab: true },
                            React__default.createElement(AnnouncementBarArrowMobile, { fill: announcementTextColor })))))))));
}

export { AnnouncementBar as default };
//# sourceMappingURL=AnouncementBar.js.map
